import type { FC } from "react"

import {
  ACCOUNTS_PAYABLE_TRANSACTION_TYPE_TO_CLASS_NAME,
  ACCOUNTS_PAYABLE_TRANSACTION_TYPE_TO_LABEL,
  INVOICE_STATUS_TO_ACCOUNTS_PAYABLE_TRANSACTION_TYPE,
} from "../../constants/accountsPayable"

import StyledChip from "@/components/common/Chip/Chip"
import type { InvoiceStatus } from "@/graphql/codegen/graphql"

interface AccountsPayableTransactionTypeChipProps {
  invoiceAction: InvoiceStatus
}

export const AccountsPayableTransactionTypeChip: FC<AccountsPayableTransactionTypeChipProps> = ({ invoiceAction }) => {
  const type = INVOICE_STATUS_TO_ACCOUNTS_PAYABLE_TRANSACTION_TYPE[invoiceAction]

  return (
    <StyledChip
      label={ACCOUNTS_PAYABLE_TRANSACTION_TYPE_TO_LABEL[type]}
      className={ACCOUNTS_PAYABLE_TRANSACTION_TYPE_TO_CLASS_NAME[type]}
      size='small'
    />
  )
}
